export default {
  // ? ==========================
  // ? =====  Multilocation  ====
  // ? ==========================

  multiLocation: {},

  // ? ===================
  // ? =====  Layout  ====
  // ? ===================

  navigation: {
    '.logoLocationContainer': {
      height: 'auto',
      padding: '0rem',
      margin: '0rem auto 0rem 0rem',
      position: 'static'
    },
    '.logo': {
      a: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
      img: {
        maxHeight: ['100px', '100px', '100px', '115px'],
        filter: 'unset'
      }
    },
    '.privacy-policy': {
      display: 'none!important'
    },
    '.logoScrolled': {
      a: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
      img: {
        maxHeight: ['50px', '60px', '60px', '60px'],
        filter: 'unset',
        padding: '0rem'
      }
    },

    '.container': {
      padding: ['1rem 1rem 1rem', '1rem 2rem 1rem', '1rem 2rem 1rem', '1rem 2rem'],
      position: 'static',
      backgroundColor: 'transparent',
      top: '0rem',
      position: 'relative',
      borderBottom: '1px solid'
      // borderColor: 'text'
    },
    '.containerScrolled': {
      padding: '0.5rem 1rem',
      backgroundColor: 'background',
      position: 'fixed',
      right: '0rem',
      top: '0rem',
      left: 'unset',
      border: 'none',
      borderBottom: '1px solid',
      borderColor: 'primary',
      '.phoneContainer': {
        display: 'none'
      }
    },
    '.hamburger': {
      borderRadius: '100px',
      padding: '0.75rem',
      borderColor: 'primary',
      backgroundColor: 'rgba(255,255,255, 0.6)',
      display: ['', '', '', 'none'],
      mr: '0rem',
      '> div': {
        backgroundColor: 'primary'
      }
    },
    '.smallNavMenu': {
      alignItems: 'center',
      padding: '0.25rem',
      '.navItem': {
        padding: '0rem',
        height: 'fit-content',
        a: {
          letterSpacing: '0px',
          textTransform: 'lowercase',
          fontSize: ['0.9rem', '0.9rem', '0.9rem', '0.9rem', '1rem', '1rem']
        },
        color: 'text',
        ':hover': {
          color: 'primary'
        }
      },

      '.navItemDropdownMenu': {
        backgroundColor: 'background',
        '.navItem': {
          m: '0.5rem'
        }
      },

      '.order-online': {
        backgroundColor: 'transparent',
        padding: '0.75rem 1.5rem',
        border: 'solid 1px',
        borderColor: 'dark',
        ml: '2rem',
        ':hover': {
          color: 'primary',
          a: { color: 'primary' },
          borderColor: 'primary'
        }
      },
      '.reservations': {
        backgroundColor: 'primary',
        padding: '0.75rem 1.5rem',
        color: 'white',
        border: 'solid 1px',
        borderColor: 'primary',
        ':hover': {
          color: 'primary',
          a: { color: 'primary' },
          backgroundColor: 'transparent',
          borderColor: 'primary'
        }
      }
    },

    '.phoneContainer': {
      display: ['none', '', 'none'],
      position: 'absolute',
      top: '0rem',
      margin: '0rem',
      left: '0rem',
      border: 'none',
      width: '100%',
      backgroundColor: 'primary',
      justifyContent: 'flex-end',
      padding: '0.75rem',
      a: {
        '::before': {
          content: "'Have a catering event?'",
          marginRight: '0.5rem',
          fontSize: '0.9rem'
        },
        textAlign: 'center',
        color: 'light',
        fontSize: '0.9rem',
        svg: {
          display: 'none'
        },
        ':hover': {
          opacity: '0.7',
          color: 'light',
          fontSize: '0.9rem'
        }
      }
    },
    '.hamburgerOpen': {
      borderColor: 'white',
      '> div': {
        backgroundColor: 'light'
      }
    },
    '.navMenuLogo': {
      display: 'none'
    },
    '.navMenu': {
      transform: 'unset',
      top: '0rem',
      transition: 'all ease-in-out 0.5s',
      height: '100vh',
      left: '-200vw'
    },
    '.navMenuOpen': {
      alignItems: ['', '', '', 'flex-end'],
      textAlign: ['', '', '', 'right'],
      padding: ['', '', '', '4rem'],
      width: '80%',
      maxWidth: '500px',
      backgroundColor: 'primary',
      '.navItem': {
        a: {
          color: 'light',
          ':hover': {
            textDecoration: 'underline'
          }
        }
      },
      '.seperatorLine': {
        margin: ['', '', '', '1rem 0 1rem auto']
      },
      '.phoneSocialContainer': {
        flexDirection: ['', '', '', 'column'],
        alignItems: ['', '', '', 'flex-end'],
        textAlign: ['', '', '', 'right'],
        a: {
          textAlign: ['', '', '', 'right'],
          justifyContent: ['', '', '', 'flex-end'],
          fontSize: '1rem',
          fontFamily: 'heading'
        }
      },
      '.smallNavHeading ': {
        textAlign: ['', '', '', 'right'],
        color: 'white',
        fontFamily: 'heading'
      },

      '.socialIconsContainer': {
        alignItems: ['', '', '', 'flex-end'],
        textAlign: ['', '', '', 'right'],
        '.smallNavHeading ': {
          textAlign: 'right'
        },
        a: {
          textAlign: ['', '', '', 'right'],
          justifyContent: ['', '', '', 'flex-end'],
          fontSize: '1rem',
          svg: {
            path: {
              fill: 'white'
            }
          }
        }
      }
    },
    '.navBlock': {
      right: 'unset',
      top: '200vh'
    }
  },

  footer: {
    backgroundColor: 'background',
    display: 'flex',
    color: 'text',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    padding: ['2rem 0.5rem 6rem', '', '2rem 3rem'],
    borderTop: 'solid 1px',
    borderColor: 'text',
    '.image': {
      display: 'none'
    },
    '.multiButtonContainer': {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignItems: 'center',
      a: {
        width: 'fit-content',
        textTransform: 'uppercase',
        fontSize: '1.1rem',
        fontFamily: 'heading',
        color: 'inherit'
      }
    },
    '.contactDetails-container': {
      display: 'none'
    },
    '.copyright': {
      width: '50%',
      color: 'text',
      textAlign: 'center'
    },
    '.poweredByText': {
      margin: 'auto',
      color: 'text',
      fill: 'text'
    },
    '.socialIconsContainer': {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: '1rem',

      a: {
        padding: '0.5rem',
        color: 'text',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        ':hover': {
          backgroundColor: 'dark'
        },
        svg: {
          width: '30px',
          height: '30px'
        }
      }
    },
    '.gonationLogo': {
      filter: 'unset',
      width: '50%'
    }
  },

  ctaWidget: {},

  // ? ====================
  // ? ==== Reuseables ====
  // ? ====================

  title: {
    fontSize: ['2rem', '2.1rem', '2.25rem', '2.5rem', '2.75em'],
    fontWeight: '300',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    textAlign: 'inherit',
    marginBottom: '1.5rem',
    textTransform: 'lowercase',
    fontFamily: 'heading'
  },
  subtitle: {
    width: 'fit-content',
    textAlign: 'inherit',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: ['1.5rem', '1.75rem', '2rem', '2rem'],
    marginBottom: '1.5rem',
    border: 'none',
    color: 'text2',
    fontFamily: 'subheading',
    opacity: '0.8',
    fontWeight: '200'
  },
  text: {
    lineHeight: '1.75',
    fontSize: ['1rem', '', '1.1rem'],
    padding: '0.25rem 0rem',
    opacity: '0.6',
    p: {
      color: 'inherit',
      lineHeight: '2',
      textAlign: 'inherit',
      fontSize: ['1rem', '', '1.1rem']
    }
  },

  sideBySide1: {
    height: ['', '', '85vh', '85vh'],
    padding: ['1rem', '', '3rem'],
    backgroundColor: 'background',
    // backgroundImage:
    //   'url(https://media.gonation.com/w_800/sites/yeros/yysvohfwe9nhnzrgdqj1_2.png)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '15%',
    backgroundPosition: ['95% 0%', '', '105% 100%', '105% 100%', '100% 100%'],
    margin: '0rem',
    '.lazyload-wrapper': {
      minHeight: '50vh',
      justifyContent: 'flex-start',
      width: ['', '', '60%', '60%'],
      zIndex: '10'
    },
    '.content': {
      position: 'relative',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      margin: ['1rem 0rem', '', '0rem'],
      width: ['', '', '40%', '40%'],
      zIndex: '1'
    },
    '.title': {
      variant: 'customVariants.title',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      '::after': {
        content: "''",
        height: '3px',
        width: '100%',
        backgroundColor: 'primary',
        my: '1.5rem',
        position: 'relative',
        left: '-40%'
      }
    },
    '.subtitle': {
      variant: 'customVariants.subtitle'
    },
    '.text': {
      variant: 'customVariants.text',
      mb: '2rem',
      color: 'black',
      maxWidth: '480px'
    },
    a: {
      order: '5'
    },
    '.ctaButton': {
      variant: 'buttons.primary'
    }
  },

  sideBySide2: {
    variant: 'customVariants.sideBySide1'
  },

  // ? ====================
  // ? ====  Homepage  ====
  // ? ====================

  homepageHero: {
    backgroundColor: '#1260ac42',
    height: ['calc(100vh - 100px)', '', 'calc(100vh - 147px)', 'calc(100vh - 147px)'],
    width: '100%',
    justifyContent: 'flex-start',

    position: 'relative',
    mb: ['6rem', '', '', '0rem'],

    '#preventMouseEffects': {
      background: 'none'
    },

    '.hero_content_container': {
      border: 'none',
      transform: ['', '', '', 'translateX(-50%)'],
      bottom: '0rem',
      left: '50%',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0rem auto',
      width: '100%',
      maxWidth: '767px',
      a: {
        alignSelf: ['center', 'center', 'center', 'center', 'center']
      }
    },

    '.title': {
      variant: 'customVariants.title',
      fontSize: ['2.5rem', '2.75rem', '3.25rem', '3.5rem', '3.75em']
    },
    '.subtitle': {
      variant: 'customVariants.subtitle',
      fontSize: ['2rem', '2.1rem', '2.25rem', '2.5rem', '2.75em'],
      color: '#9fc8f0'
    },
    '.text': {
      variant: 'customVariants.text'
    },
    a: {
      width: '100%',
      order: '4'
    },
    '.ctaButton': {
      variant: 'buttons.primary',
      color: 'white',
      m: 'auto',

      borderTop: 'solid 1px',
      borderBottom: 'solid 1px',
      borderColor: 'white',
      p: '1rem',
      width: 'fit-content'
    }
  },
  homepageHeroShout: {
    display: 'none'
  },
  homepageShout: {
    backgroundColor: 'background',
    marginBottom: ['5rem', '', '0rem'],
    marginTop: '3rem',
    padding: ['1rem', '', '2rem 1rem', '3rem 2rem 6rem', '3rem 3rem 6rem'],
    flexWrap: ['wrap', 'wrap', 'wrap', 'wrap'],
    '.title': {
      variant: 'customVariants.title',
      borderBottom: '3px solid',
      borderColor: 'text2',
      fontFamily: 'heading',
      width: ['', '', '70%'],
      backgroundColor: 'transparent',
      letterSpacing: '0px',
      color: 'text',
      fontSize: ['1rem', '1.1rem', '1.2rem', '1.3rem', '1.3rem']
    },
    '.text': {
      variant: 'customVariants.text',
      fontFamily: 'heading',
      fontSize: ['1.25rem', '', ''],
      order: ['4', '', '3'],
      border: ['', '', '', 'solid 0.5rem'],
      borderColor: ['', '', '', 'white'],
      fontWeight: 'normal',
      padding: ['', '', '0rem 2rem'],
      backgroundColor: ['backgroundSecondary'],
      textTransform: ['', '', ''],
      padding: ['2rem', '2rem'],
      marginTop: ['', '0rem', '', '3rem'],
      width: ['', '', '45%', '45%', '55%']
    },
    '.date': {
      backgroundColor: ['transparent', '', 'primary'],
      border: ['solid 1px', '', '', 'solid 0.5rem'],
      borderColor: ['dark', '', '', 'white'],
      fontSize: '0.8rem',
      maxWidth: 'unset',
      color: ['dark', '', 'white'],
      flexGrow: '1',
      fontWeight: 'bold',
      justifyContent: 'center',
      position: 'relative',
      left: ['', '', '', '-3rem'],
      bottom: ['', '', '', '-2rem']
    },
    '.imageContainer': {
      position: 'relative',
      mt: ['0.5rem', '', '0rem', '', ''],
      top: ['', '', '', '2.5rem'],
      border: ['', '', '', 'solid 0.5rem'],
      borderColor: ['', '', '', 'white'],
      order: ['', '', '4'],
      cursor: 'pointer',
      flexGrow: '1',
      '.imageFill': {
        paddingBottom: ['100%', '70%', '70%']
      }
    },
    '.shoutCTABtns ': {
      border: ['', '', '', 'solid 8px'],
      borderColor: ['', '', '', 'background'],
      flexDirection: ['row', 'row', 'row', 'column'],
      width: ['100%', '', '', 'auto'],
      order: ['6', '', '5', '5'],
      // marginLeft: ['0rem', '', '0rem'],
      a: {
        width: ['fit-content', '', '', 'fit-content'],
        flexGrow: 'unset',
        writingMode: ['unset', 'unset', 'unset', 'tb'],
        padding: ['1rem 3.5rem', '', '', '3.5rem 1rem'],
        backgroundColor: 'transparent',
        color: 'grey',
        borderColor: 'grey',
        fontFamily: 'sans-serif',
        fontWeight: 'normal',
        letterSpacing: '0px',
        ':hover': {
          backgroundColor: 'primary',
          color: 'white',
          borderColor: 'primary'
        }
      }
    }
  },

  homepageAbout: {
    variant: 'customVariants.sideBySide1',
    backgroundColor: 'backgroundTertiary',
    '.lazyload-wrapper': {
      width: ['', '', '40%'],
      '.image': {
        objectFit: 'cover',
        objectPosition: 'center'
      }
    },
    'div.content': {
      alignItems: ['flex-start', '', 'flex-start'],
      width: ['', '', '60%'],
      padding: ['1rem', '2rem', '3rem', '4rem', '5rem']
    }
  },

  homepageMenu: {
    variant: 'customVariants.sideBySide1',
    height: ['', '', '100vh', '100vh', '100vh', '100vh'],
    '.section': {
      height: 'fit-content',
      alignItems: ['center', 'center', 'center', 'center'],
      margin: 'auto',
      padding: ['2rem', '', '3rem', '4rem', '5rem'],
      backgroundColor: '#5c7b9aeb',
      '*': {
        color: 'white'
      },
      '.title': {
        variant: 'customVariants.title',
        '::after': { content: 'none' }
      },
      '.text': {
        maxWidth: '500px',
        margin: 'auto',
        color: 'white',
        '*': {
          textAlign: 'center'
        }
      },
      '.linksContainer': {
        mt: '1.5rem',
        justifyContent: 'center',
        alignItems: ['center', 'center', 'center', 'center']
      },
      '.ctaButton': {
        variant: 'buttons.primary',
        color: 'white',
        borderColor: 'white'
      }
    }
  },
  policy: {
    variant: 'customVariants.sideBySide1',
    height: 'auto',
    '.title': {
      color: 'primary'
    },
    '.section, .text': {
      maxWidth: '1200px'
    }
  },
  homepageBoxes: {
    backgroundColor: 'primary',
    padding: ['2rem', '', '', '3rem', '4rem', '5rem'],
    '.box': {
      width: ['100%', '', 'calc(50% - 3rem)', 'calc(50% - 3rem)'],
      margin: '1.5rem',
      transition: 'all ease-in-out 1s',
      borderRadius: '0px',
      textAlign: 'center',
      alignItems: 'center',
      ':hover': {
        '.image': {
          filter: 'unset'
        }
      },
      '.image': {
        filter: 'grayscale(70%)',
        height: ['auto', '', '450px', '400px', '500px', '550px', '600px'],
        objectFit: 'cover',
        transition: 'all ease-in-out 0.5s'
      },
      '.title': {
        variant: 'customVariants.title',
        transition: 'all ease-in-out 1s',
        mt: '1rem',
        marginBottom: '0rem',
        padding: '0rem',
        paddingBottom: '0.5rem',
        color: 'white'
      },
      '.subtitle': {
        variant: 'customVariants.subtitle',
        fontWeight: '300'
      },
      '.text': {
        variant: 'customVariants.text',
        padding: '1rem 0rem 1rem',
        textAlign: 'center',
        maxWidth: '700px',
        color: 'white'
      },
      '.ctaLink': {
        variant: 'buttons.primary',
        margin: '0rem',
        backgroundColor: 'white',
        ':hover': {
          backgroundColor: 'secondary',
          color: 'white',
          borderColor: 'white'
        }
      }
    }
  },
  homepageCatering: {
    variant: 'customVariants.homepageMenu'
  },

  // ? ========================
  // ? =====  About page  =====
  // ? ========================

  aboutSection: {
    padding: '20vh 2rem 20vh',
    '.title': {
      variant: 'customVariants.title',
      borderBottom: '2px solid',
      borderColor: 'primary'
    },
    '.text': {
      lineHeight: '2.5'
    }
  },

  AboutOwners: {
    variant: 'customVariants.sideBySide1',
    marginTop: '0rem',
    backgroundColor: '#e9e9e2',
    padding: '5rem 2rem 5rem',
    height: ['unset', 'unset', 'unset', 'unset', 'unset'],
    'div.content': {
      width: ['', '', '60%']
    },

    'div.lazyload-wrapper': {
      overflow: 'hidden',
      padding: ['', '', '2rem 3rem'],
      width: ['', '', '40%'],
      img: {
        objectFit: 'cover',
        objectPosition: 'top'
      }
    }
  },

  // ? =======================
  // ? =====  Menu page  =====
  // ? =======================

  menuCTAS: {
    padding: '3rem 1rem 0rem',

    '.ctaButton, .secondaryCtaButton': {
      variant: 'buttons.primary',
      borderRadius: '500px',
      margin: '0 auto'
    }
  },

  menu: {
    '.menuTab': {
      fontFamily: 'body',
      variant: 'buttons.primary',
      borderRadius: '500px',
      fontFamily: 'body',
      textTransform: 'uppercase'
    },
    '.menuTabActive': {
      backgroundColor: 'primary',
      borderColor: 'primary',
      color: 'white'
    }
  },

  // ? ========================
  // ? ====  Partners page  ====
  // ? ========================

  ourPartners: {},

  // ? ========================
  // ? ====  Gallery page  ====
  // ? ========================

  gallery: {
    '.albumTitle': {
      padding: '0.5rem'
    },
    '.sauces ': {
      '.albumImage': {
        objectFit: 'contain',
        gridRowEnd: 'span 2'
      }
    }
  },

  // ? ========================
  // ? ====  Events page  ====
  // ? ========================

  events: {
    '.events-container': {
      maxWidth: 'unset'
    },
    '.no-events-container': {
      padding: '10rem 1rem',
      img: {
        maxHeight: '70px'
        // filter: 'brightness(0) invert(1)',
      }
    },

    '.eventItemImage': {
      minHeight: 'unset',
      width: '25%'
      // height: '100%',
    },
    '.eventDays, .eventDate': {
      color: 'primary'
    },
    '.eventItemDescription': {
      maxHeight: '250px',
      overflowY: 'scroll',
      '::-webkit-scrollbar': {
        display: 'none'
      },
      '-ms-overflow-style': 'none' /* IE and Edge */,
      scrollbarWidth: 'none'
    }
  },

  // ? ========================
  // ? ====  Contact page  ====
  // ? ========================

  contactForm: {
    order: '4',
    h2: {
      variant: 'customVariants.title',
      order: 'unset',
      fontSize: ['1.75rem', '2rem', '2rem', '2.5rem']
    },
    '.text': {
      color: 'white'
    },

    color: 'white',

    padding: ['3rem 1rem', '', '6rem 1rem'],
    form: {
      mt: '2.5rem',
      maxWidth: '500px'
    },
    '.inputField, .textField ': {
      fontWeight: '300',
      border: 'none',
      borderBottom: '1px solid',
      borderColor: '#72aee7',

      backgroundColor: 'rgba(0,0,0,0.65)',
      borderRadius: '10px',
      padding: '1.5rem 0.5rem',
      color: 'white',
      fontFamily: 'heading',
      '::placeholder': {
        color: 'white'
      }
    },
    textarea: {
      '::placeholder': {
        color: 'text',
        fontWeight: '300',
        fontFamily: 'heading'
      }
    },

    '.submitBtn': {
      variant: 'buttons.secondary',
      padding: '1rem 2rem',
      height: 'unset',
      width: 'auto',
      borderRadius: '10px',
      marginTop: '1.5rem',
      ':hover': {
        borderColor: 'dark',
        backgroundColor: 'dark'
      }
    }
  },

  locationMap: {
    display: 'flex',
    flexDirection: ['column', 'column', 'column', 'column'],
    justifyContent: 'center',
    alignItems: 'center',
    order: '3',
    padding: '5vh 2rem',
    '.content_container': {
      padding: '0rem',
      justifyContent: 'flex-start'
    },

    h3: {
      variant: 'customVariants.title',
      justifyContent: 'center',
      display: 'flex',
      order: 'unset',

      borderBottom: '1px solid',
      padding: '1rem',
      mb: '2rem',
      textAlign: 'center',
      alignItems: 'center',
      color: 'text',
      marginBottom: '0rem !important'
    },
    '.contactDetails-container': {
      padding: '1rem 1rem 2rem',
      '.text': {
        fontSize: '0.9rem'
      }
    },
    '.hours-section': {
      maxWidth: 'unset',
      padding: '0rem',
      mb: '3rem !important',
      '.hoursContainer': {
        padding: ['1rem', '2rem', '3rem 4rem', '1rem 5rem'],
        '.dayContainer': {
          mb: '0.5rem'
        },
        '.dayofWeekText': {
          mb: '0rem',
          border: 'none'
        },
        '.timeBlocks': {
          justifyContent: 'flex-start'
        }
      }
    },
    '.dayofWeekText': {
      margin: '0 auto 1rem 0',
      borderBottom: '1px solid'
    },
    '.textContent': {
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      display: 'flex'
    }
  },

  // ? ========================
  // ? ====  Press page  ====
  // ? ========================

  pressMenu: {
    padding: ['1rem', '1rem', '1rem', '1rem'],
    backgroundColor: 'background',
    '.boxesHeading': {
      textAign: 'left',
      margin: '1rem',
      borderBottom: '2px solid',
      width: 'calc(100% - 2rem)',
      fontSize: ['2rem', '2.5rem', '2.5rem'],
      textAlign: 'left',
      justifyContent: 'flex-start'
    },

    '.boxesContainer': {
      justifyContent: 'flex-start'
    },
    '.box': {
      flexGrow: 1,
      maxWidth: '360px'
    },
    '.textContent': {
      backgroundColor: 'white',
      '.subtitle': {
        color: 'dark',
        fontSize: '1rem'
      }
    },
    '.imageContainer': {
      backgroundColor: 'white',
      img: {
        objectFit: 'cover',
        padding: '1rem'
      }
    }
  },

  pressPage: {
    backgroundColor: 'background'
  },

  // ? ============================================
  // ? ====  Private Events and Catering page  ====
  // ? ============================================

  privateEventsIntro: {
    padding: '20vh 2rem 20vh',
    background: 'background',
    '.title': {
      variant: 'customVariants.title',
      borderBottom: '2px solid',
      borderColor: 'primary'
    },
    '.text': {
      p: {
        lineHeight: '2.5'
      }
    }
  }
}
